module.exports = __webpack_public_path__ + "static/media/loop.a181e1d9.svg";